import * as React from 'react'
import {
  Datagrid,
  List,
  TextField,
  DateField,
} from 'react-admin'

export default props => (
  <List {...props} title="Usuários">
    <Datagrid rowClick="edit">
      <TextField label="Nome" source="name" />
      <TextField label="Email" source="email" />
      <DateField label="Criado em" source="createdAt" locales="pt-BR" showTime />
    </Datagrid>
  </List>
)
